var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHouseSize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 213 199",
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "house-size_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h213v199H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#house-size_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67 41h4v108h-4zm122 0h4v108h-4zm-75 50h4v53h-4zm-43 53h118v5H71zm71-53h4v53h-4zm-24 0h24v5h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.735 0l2.12 3.392-82.256 51.41-2.12-3.392z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62 3.392L130.74 0l82.256 51.41-2.12 3.392zM63 178h133v5H63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.556 165.345l2.828 2.828-15.556 15.557L58 180.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 180.828L60.828 178l15.557 15.556-2.829 2.828zm125-12.655l2.828-2.828 15.557 15.556-2.829 2.828z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.556 178.001l2.828 2.828-15.556 15.557-2.828-2.829zM21.557 8.116v133h-5v-133z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.384 128.115l2.828 2.828L18.656 146.5l-2.828-2.829z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.557 143.672l-2.828 2.828-15.557-15.556 2.829-2.828zm12.656-125L31.385 21.5 15.828 5.944l2.829-2.828z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.729 3.116l2.828 2.828L6.001 21.501l-2.828-2.829z"
  }))));
}

export default SvgHouseSize;